import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import Autoplay from "%/dynamic-component-editor/options/autoplay";
import MuteOnAutoplay from "%/dynamic-component-editor/options/mute-on-autoplay";
import VideoControlsStyle from "%/dynamic-component-editor/options/video-controls-style";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class StoryMediaPlaybackOptions extends BaseOptionsBundle {
  optionTitle = "Playback";
  static optionClassName = "i-dynamic-story-media-playback";
  inspectorToolGroup = "video";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.VIDEO_TOOLSET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Autoplay(undefined, hideFromInspector["autoplay"] ?? false),
      new MuteOnAutoplay(undefined, hideFromInspector["mute-on-autoplay"] ?? false),
      new VideoControlsStyle(undefined, hideFromInspector["video-controls-style"] ?? false),
    ]);
  }
}
